// ══════════════════════════════════════════════
//  套餐配置 - Mock 数据
//  TODO: 联调时替换为接口数据
//  字段命名与真实接口保持一致（价格单位为「分」）
// ══════════════════════════════════════════════

export const MOCK_APPS = [
    { appId: 'app1', appName: 'HomeStar', appCode: 'APP_HOMESTAR' },
    { appId: 'app2', appName: 'SmartHome Pro', appCode: 'APP_SMARTHOME' },
    { appId: 'app3', appName: 'CloudCam', appCode: 'APP_CLOUDCAM' },
];

// 生效时长（真实由 getDurationList(applicationDirection) 返回，按方向不同）
export const MOCK_DURATION_MAP = {
    1: [
        { serviceDuration: 7, serviceDurationUnit: 1 },   // 7天
        { serviceDuration: 1, serviceDurationUnit: 2 },   // 1个月
        { serviceDuration: 1, serviceDurationUnit: 3 },   // 1年
    ],
    2: [
        { serviceDuration: 1, serviceDurationUnit: 2 },   // 1个月
        { serviceDuration: 6, serviceDurationUnit: 2 },   // 6个月
        { serviceDuration: 1, serviceDurationUnit: 3 },   // 1年
    ],
};

export const DURATION_UNIT_MAP = { 1: '天', 2: '月', 3: '年' };

// 套餐模板（真实由 getPackageTemplateList 按方向+时长返回）
export const MOCK_TEMPLATES = [
    { id: 'tpl_001', name: '全天云存-标清版', serviceType: '全天云存', direction: 1, durations: ['7-1', '1-2', '1-3'], deviceLimit: 1, costCNY: 1500, costUSD: 220, description: '全天候无间断录制，云端滚动存储。' },
    { id: 'tpl_002', name: '事件云存-极速版', serviceType: '事件云存', direction: 1, durations: ['7-1', '1-2', '1-3'], deviceLimit: 2, costCNY: 800, costUSD: 120, description: '检测到动态事件时自动录制并上传云端。' },
    { id: 'tpl_009', name: '全天云存-超清版', serviceType: '全天云存', direction: 1, durations: ['1-2', '1-3'], deviceLimit: 2, costCNY: 2500, costUSD: 350, description: '4K 超清画质，极致录制细节，云端滚动存储。' },
    { id: 'tpl_003', name: 'AI鸟类智能识别', serviceType: '鸟类识别', direction: 1, durations: ['1-2', '1-3'], deviceLimit: 3, costCNY: 500, costUSD: 80, description: '精准识别多种常见鸟类，支持推送提醒。' },
    { id: 'tpl_005', name: '短信提醒-基础套餐', serviceType: '短信通知', direction: 2, durations: ['1-2', '6-2', '1-3'], deviceLimit: null, costCNY: 200, costUSD: 30, description: '包含每月 50 条短信通知，覆盖告警与系统动态。' },
    { id: 'tpl_007', name: 'App全站去广告', serviceType: '去广告', direction: 2, durations: ['1-2', '6-2', '1-3'], deviceLimit: null, costCNY: 300, costUSD: 45, description: '移除 App 内所有启动页、弹窗及横幅广告，极简体验。' },
];

// 套餐标签（真实由 getTags 返回）
export const MOCK_PKG_TAGS = [
    { id: 'hot', name: '热门推荐' },
    { id: 'new', name: '新品上市' },
    { id: 'discount', name: '限时优惠' },
    { id: 'top1', name: '销量第一' },
];

// 套餐描述标签（真实由 getDescTags 返回）
export const MOCK_DESC_TAGS = [
    { id: 'd1', name: '支持 3 天循环录像' },
    { id: 'd2', name: '支持 7 天循环录像' },
    { id: 'd3', name: '支持 30 天循环录像' },
    { id: 'd4', name: '高清画质，极速回放' },
];

// 套餐分类已从套餐配置移除（生产环境无此概念）

export const REGION_MAP = { 1: '国内', 2: '海外' };
export const OPERATION_POSITION_OPTIONS = ['商城位', '推荐位'];

// 区域定价模板（真实由 getRegionPricingTemplateList 返回；单位：分）
// 仅覆盖售价，不含划线价；国内固定 CNY 不参与
export const INIT_REGION_PRICING_TEMPLATES = [
    {
        id: 'rpt_001', name: '东南亚标准价', defaultUsd: 99,
        countryOverrides: [
            { country: 'SG', usdPrice: 99 }, { country: 'MY', usdPrice: 89 },
            { country: 'TH', usdPrice: 89 }, { country: 'ID', usdPrice: 89 },
            { country: 'VN', usdPrice: 89 },
        ],
    },
    {
        id: 'rpt_002', name: '欧美统一价', defaultUsd: 129,
        countryOverrides: [
            { country: 'US', usdPrice: 149 }, { country: 'GB', usdPrice: 119 },
            { country: 'DE', usdPrice: 119 }, { country: 'FR', usdPrice: 119 },
        ],
    },
    {
        id: 'rpt_003', name: '海外统一价', defaultUsd: 99,
        countryOverrides: [],
    },
];

// 套餐列表（价格单位：分）
export const INIT_PACKAGES = [
    {
        packageId: 'PKG2024003', name: '事件录像7天', packageLabel: ['热门推荐', '销量第一'],
        applicationDirection: 1, releaseArea: ['1', '2'],
        releaseAppList: [{ appName: 'HomeStar', appCount: 2 }, { appName: 'SmartHome Pro', appCount: 1 }],
        releaseOpsPosition: ['商城位', '推荐位'],
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        platformCostCny: 250, platformCostUsd: 35,
        salePriceCny: 690,
        subscriptionRegionPricing: { defaultUsd: 95, countryOverrides: [{ country: 'US', usdPrice: 120 }, { country: 'GB', usdPrice: 90 }] },
        noSubscriptionPriceCny: null,
        noSubscriptionRegionPricing: null,
        createdAt: 1768608000,
    },
    {
        packageId: 'PKG2024010', name: '国内专享-标清云存', packageLabel: ['新品上市'],
        applicationDirection: 2, releaseArea: ['1'],
        releaseAppList: [{ appName: 'HomeStar', appCount: 3 }, { appName: 'CloudCam', appCount: 2 }],
        releaseOpsPosition: ['商城位'],
        isFree: 0, isSubscription: 1, isNoSubscription: 1,
        platformCostCny: 1500, platformCostUsd: null,
        salePriceCny: 9900,
        subscriptionRegionPricing: null,
        noSubscriptionPriceCny: 12900,
        noSubscriptionRegionPricing: null,
        createdAt: 1774458000,
    },
    {
        packageId: 'PKG2024011', name: 'Overseas-Pro', packageLabel: [],
        applicationDirection: 1, releaseArea: ['2'],
        releaseAppList: [{ appName: 'HomeStar', appCount: 1 }],
        releaseOpsPosition: ['推荐位'],
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        platformCostCny: null, platformCostUsd: 350,
        salePriceCny: null,
        subscriptionRegionPricing: { defaultUsd: 1299, countryOverrides: [{ country: 'US', usdPrice: 1499 }] },
        noSubscriptionPriceCny: null,
        noSubscriptionRegionPricing: null,
        createdAt: 1774542600,
    },
    {
        packageId: 'PKG2024015', name: '新用户免费体验包', packageLabel: ['限时优惠'],
        applicationDirection: 2, releaseArea: ['1', '2'],
        releaseAppList: [{ appName: 'HomeStar', appCount: 1 }, { appName: 'SmartHome Pro', appCount: 1 }, { appName: 'CloudCam', appCount: 1 }],
        releaseOpsPosition: ['商城位', '推荐位'],
        isFree: 1, isSubscription: 0, isNoSubscription: 0,
        platformCostCny: 200, platformCostUsd: 30,
        salePriceCny: null,
        subscriptionRegionPricing: null,
        noSubscriptionPriceCny: null,
        noSubscriptionRegionPricing: null,
        createdAt: 1775664000,
    },
    {
        packageId: 'PKG2024020', name: 'AI智能检测月卡', packageLabel: ['热门推荐'],
        applicationDirection: 1, releaseArea: ['1'],
        releaseAppList: [{ appName: 'SmartHome Pro', appCount: 2 }],
        releaseOpsPosition: ['商城位'],
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        platformCostCny: 500, platformCostUsd: 80,
        salePriceCny: 1990,
        subscriptionRegionPricing: null,
        noSubscriptionPriceCny: null,
        noSubscriptionRegionPricing: null,
        createdAt: 1776873600,
    },
    {
        packageId: 'PKG2024025', name: '全家桶年度套餐', packageLabel: ['销量第一'],
        applicationDirection: 2, releaseArea: ['1', '2'],
        releaseAppList: [{ appName: 'HomeStar', appCount: 3 }],
        releaseOpsPosition: ['推荐位'],
        isFree: 0, isSubscription: 0, isNoSubscription: 1,
        platformCostCny: 3000, platformCostUsd: 450,
        salePriceCny: null,
        subscriptionRegionPricing: null,
        noSubscriptionPriceCny: 19900,
        noSubscriptionRegionPricing: { defaultUsd: 2999, countryOverrides: [{ country: 'JP', usdPrice: 3200 }] },
        createdAt: 1777305600,
    },
];
